module.exports = __webpack_public_path__ + "static/media/pre_press.8f965f83.jpg";